import PropTypes from "prop-types";
import React from "react";
import Sections from "theme/components/contentBlocks/TextSection";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    > :not(:is(p, span)) {
        margin-top: 32px;
        margin-bottom: 12px;
    }

    > :first-child {
        margin-top: 0;
    }
    > :last-child {
        margin-bottom: 0;
    }
`;

const TextSectionBlock = ({ data, isCustomerService }) => {
    const { data: moduleData, module_settings: moduleSettings } = data || {};
    const { content_type: contentType = "wysiwyg" } = moduleSettings || {};

    if (contentType === "wysiwyg") {
        return (
            <Wrapper>
                <Wysiwyg
                    data={moduleData.wysiwyg}
                    textComponent={(props) => (
                        <TextStyles
                            as="p"
                            textStyles={isCustomerService ? "Myriad Pro/18-140" : "Myriad Pro/16-140"}
                            {...props}
                        />
                    )}
                />
            </Wrapper>
        );
    }

    if (contentType === "sections") {
        return <Sections isCustomerService={isCustomerService} sections={moduleData.sections} />;
    }

    return null;
};

TextSectionBlock.propTypes = {
    data: PropTypes.object,
    isCustomerService: PropTypes.bool,
};

TextSectionBlock.defaultProps = {
    data: {},
    isCustomerService: false,
};

export default TextSectionBlock;
